import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Button, Card, CardContent, Grid } from '@mui/material'
import { Plus } from 'react-feather'
import { LinearLoading } from 'common'

import { useFechInitLeases } from './hooks'

import { ModalModule } from './ModalModule'
import { AppliesForm } from './AppliesForm'
import { AppliesTable } from './AppliesTable'

const LeasesApplies = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitLeases({location, paramsURL})

    const {
        globalStates,
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm} = globalStates

    const { handleClickShowForm } = Actions

    const {fetchAllLeaseApplications } = FetchData
    const { loadingFetchLeaseApplications} = fetchAllLeaseApplications

    return (
        <AllowedAccess permissions={['96_ARRENDAMIENTOS_SOLICITUDES']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit} />
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <div className='h4 mt-1 mb-1'> Arrendamientos solicitudes</div>
                                <div className="border-bottom border-dark"></div>
                                {loadingFetchLeaseApplications && ( <LinearLoading /> )}
                                
                                <div className="d-flex justify-content-end pt-4">
                                    <Button
                                        startIcon={<Plus/>}
                                        size='medium'
                                        type='button'
                                        variant='contained' 
                                        style={{background: "#4b4b4c"}}
                                        sx={{marginTop: 4}}
                                        onClick={() => handleClickShowForm('EDITABLE')}
                                    >
                                        Agregar
                                    </Button>
                                </div>
                                
                                <div className="pt-4"></div>
                                <AppliesTable useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <AppliesForm useFetchInit={useFetchInit}/>
            )}
        </AllowedAccess>
    )
}

export {
    LeasesApplies
}
